import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "打勾",
  "use": "打勾-usage",
  "viewBox": "0 0 1128 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1128 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"打勾\"><path d=\"M451.7888 741.0688L1002.9056 84.3776l125.952 105.7792-607.4368 723.968-0.1024-0.1024-50.688 60.416L0 579.584l109.9776-123.5968 341.8112 285.0816z\" p-id=\"1410\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol